<!-- <p>peoplepulse-layout works!</p> -->
<div class="wrapper">
    <div class="sidebar" [ngClass]="{ 'collapsed': isCollapsed }" data-color="danger" data-background-color="white" data-image="./assets/img/sideimg.jpg">
        <app-peoplepulse-sidebar [isCollapsed] ="isCollapsed"></app-peoplepulse-sidebar>
        <div class="sidebar-background" style="background-image: url(./assets/img/sideimg.jpg)"></div>
    </div>
    <div class="main-panel" [ngClass]="{ 'collapsed': isCollapsed }">
        <app-peoplepulse-navbar  (toggleSidebar)="isCollapsed = $event"></app-peoplepulse-navbar>
        <router-outlet></router-outlet>
        <div *ngIf="isMaps('maps')">
            <app-peoplepulse-footer></app-peoplepulse-footer>
        </div>
    </div>
    <div class="fixed-plugin">
      <div class="modal modal-angular fade" id="buy" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-body text-center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="margin-top">
                Free Version
            </h4>
            <div class="separator"></div>
            <a href="https://www.creative-tim.com/product/material-dashboard" class="modal-button" target="_blank">
                <div class="wrapper-card">
                    <div class="image-container">
                        <img src="./assets/img/html.png" alt="unloaded">
                    </div>
                    Html5
                    <div class="separator"></div>
                    <div class="product-type">
                        FREE
                    </div>
                </div>
            </a>
            <a href="https://www.creative-tim.com/product/material-dashboard-angular2" class="modal-button" target="_blank">
                <div class="wrapper-card">
                    <div class="image-container image-angular-cli">
                        <img src="./assets/img/angular.png" alt="unloaded">
                    </div>
                    Angular
                    <div class="separator"></div>
                    <div class="product-type">
                        FREE
                    </div>
                </div>
            </a>
            <h4>
                PRO Version
            </h4>
            <div class="separator"></div>
            <a href="https://www.creative-tim.com/product/material-dashboard-pro" class="modal-button" target="_blank">
                <div class="image-container">
                    <img src="./assets/img/html.png" alt="unloaded">
                </div>
                Html5
                <div class="separator"></div>
                <div class="price">
                    from
                    <span>
                        49
                        <i class="fa fa-usd" aria-hidden="true"></i>
                    </span>
                </div>
            </a>
            <a href="https://www.creative-tim.com/product/material-dashboard-pro-angular2" class="modal-button" target="_blank">
                <div class="image-container image-angular-cli">
                    <img src="./assets/img/angular.png" alt="unloaded">
                </div>
                Angular
                <div class="separator"></div>
                <div class="price">
                    from
                    <span>
                        59
                        <i class="fa fa-usd" aria-hidden="true"></i>
                    </span>
                </div>
            </a>
        </div>
    </div>
</div>

</div>
